import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Help.svg?component
var Help_exports = /* @__PURE__ */ __exportAll({
	default: () => Help_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M9.2 9.2c0-.5.1-1 .4-1.5s.6-.8 1.1-1q.75-.3 1.5-.3c.75 0 1 .2 1.4.5s.7.7 1 1.2c.2.5.3 1 .2 1.5s-.3 1-.6 1.4-.8.7-1.2.9c-.255.128-.5.3-.7.5s-.3.5-.3.8v.9m0 3.5c-.2 0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4-.2.4-.4.4" }, null, -1), createElementVNode("path", { d: "M12 22c5.524 0 10-4.476 10-10S17.524 2 12 2 2 6.476 2 12s4.476 10 10 10" }, null, -1)])]);
}
var Help_default = { render: render$1 };
//#endregion
export { Help_exports, Help_default as default, render$1 as render };

//# sourceMappingURL=Help.svg_component.js.map